import { getLicenseType } from "../../../../../actions/Utilities/LicenseType";
import { useQuery } from "react-query";

export default function useGetLicenseType() {
  return useQuery("GetLicenseType", getLicenseType, {
    refetchOnWindowFocus: false,
  });
}
